import React, { useState } from 'react';
import { connect, useSelector } from "react-redux";
import { Dropdown, Space, Modal, theme  } from 'antd';
import Button from "components/button";
import IndexModal from "components/modal";
import {
  DownOutlined, EyeOutlined, EditOutlined, DeleteOutlined, TagOutlined, StopOutlined
} from '@ant-design/icons';
import { addActiveModal, removeActiveModal } from '../../redux/layout/layoutState';
import { useCRUDAccess } from "utils/useCRUDAccess";

const { useToken } = theme;

const CrudOption = ({ activeModals, 
	showModal, 
	hideModal, ...props}) => {
  	const { baseRoute, recordId, queryParams, deleteHandler, excludeHandler, forFinalPayHandler, additionalMenu, 
  		allowView=true, allowEdit=true, allowDelete=true, allowExclude=false, allowForFinalPay=false, viewMode = "page", 
		viewHandler, title, closeHandler, editMode = "page", editHandler, detailMode = "page", detailHandler, allowDetail=false,
		modalContainerClass, modalWidth=850, useCustomClass=true, allowCancel=false, moduleId, buttonClassName = "cursor-pointer",
		approveHandler, rejectHandler,
  		} = props;
  		
  	const { token } = useToken();

  	const [open, setOpen] = useState(false);
	const [dropdownOpen, setDropdownOpen] = useState(false);
	
	const [actionType, setActionType] = useState('delete');
	const [confirmTitle, setConfirmTitle] = useState('Confirm Delete');
	const [confirmMessage, setconfirmMessage] = useState('Are you sure you want to delete this record?');
	
	const isVisible = activeModals.includes(recordId);
	const [currentId, setCurrentId] = useState(null);

	const checkCRUDAccess = useCRUDAccess();

	const hasAccess = (action) =>
		!moduleId || checkCRUDAccess(moduleId, action);

	const canView = allowView && hasAccess("view");
	const canEdit = allowEdit && hasAccess("edit");
	const canDelete = allowDelete && hasAccess("delete");
	const canCancel = allowCancel && hasAccess("delete");

  	const menuOptions = [
		{
			key: 'view',
			label: 
				viewMode === "modal" ? (
				<span onClick={() => {
					setCurrentId(recordId);
					showModal(recordId);
				}}
				className="cursor-pointer">
					View
				</span>
				) : (
				<a
					href={`${baseRoute}/${recordId}/view${queryParams ? '?' + queryParams : ''}`}
				>
					View
				</a>
				),
			icon: <EyeOutlined />,
			available: canView ? 1 : 0,
		},
		{
			key: 'edit',
			label: 
				editMode === "modal" ? (
				<span onClick={() => {
					setCurrentId(recordId);
					showModal(recordId);
				}}
				className="cursor-pointer">
					Edit
				</span>
				) : (
				<a 
					href={`${baseRoute}/${recordId}/edit${queryParams ? '?'+queryParams : ''}`}
				>
					Edit
				</a>
				),
			icon: <EditOutlined />,
			available: canEdit ? 1 : 0,
		},
		{
			key: 'exclude',
			label: (
				<div onClick={(e) => {e.preventDefault();openConfirmation('exclude')}}>
					Exclude
				</div>
			),
			icon: <TagOutlined />,
			available: allowExclude ? 1 : 0,
		},
		{
			key: 'forfinalpay',
			label: (
				<div onClick={(e) => {e.preventDefault();openConfirmation('forfinalpay')}}>
					For Final Pay
				</div>
			),
			icon: <TagOutlined />,
			available: allowForFinalPay ? 1 : 0,
		},	
		{
			key: 'delete',
			label: (
				<div className="text-red-700 dark:text-red-400" onClick={(e) => {e.preventDefault();openConfirmation('delete')}}>
					Delete
				</div>
			),
			icon: <DeleteOutlined className="text-red-700"/>,
			available: canDelete ? 1 : 0,
		},
		{
			key: 'details',
			label: 'View Details',
			icon: <EyeOutlined />,
			available: allowDetail && !isVisible  ? 1 : 0,
			onClick: () => {
				setDropdownOpen(false);
				if (detailMode === "modal") {
					setCurrentId(recordId);
					showModal(recordId);
				} else {
					window.location.href = `${baseRoute}/${recordId}/view${queryParams ? '?' + queryParams : ''}`;
				}
			},
		},
		{
			key: 'cancel',
			label: (
				<div className="text-orange-700" onClick={(e) => {e.preventDefault();openConfirmation('cancel')}}>
					Cancel
				</div>
			),
			icon: <StopOutlined className="text-orange-700"/>,
			available: canCancel ? 1 : 0,
		},  
	];
	
	const allMenuOptions = additionalMenu ? menuOptions.concat(additionalMenu) : menuOptions;
	const items = allMenuOptions
		.filter(item => item.available === 1)
		.map(item => ({
			...item,
			onClick: item.confirm
				? () => openConfirmation(item.confirm)
				: item.onClick,
	}));
	
	const contentStyle = {
	    backgroundColor: token.colorBgElevated,
	    borderRadius: token.borderRadiusLG,
	    boxShadow: token.boxShadowSecondary,
		zIndex: 999,
  	};
	const menuStyle = {
	    boxShadow: 'none',
  	};

	const openConfirmation = (type) => {		
		setActionType(type);
		if(type === 'forfinalpay'){
			setConfirmTitle('Confirm For Final Pay');
			setconfirmMessage('Are you sure you want to set this record to for final pay type?');
		}else if(type === 'exclude'){
			setConfirmTitle('Confirm Exclude');
			setconfirmMessage('Are you sure you want to set this record to exclude type?');
		}else if(type === 'cancel'){
			setConfirmTitle('Confirm Cancel');
			setconfirmMessage('Are you sure you want to cancel this record?');
		}else if(type === 'approve'){
			setConfirmTitle('Confirm Approval');
			setconfirmMessage('Are you sure you want to approve this request?');
    	}else if(type === 'reject'){
			setConfirmTitle('Confirm Rejection');
			setconfirmMessage('Are you sure you want to reject this request?');
		}else{
			setConfirmTitle('Confirm Delete');
			setconfirmMessage('Are you sure you want to delete this record?');
		}
		
		setOpen(true);
	}

	const onClickConfirmation = () => {
		if(actionType === 'exclude'){
			excludeHandler({mode: 'reload', recordId})
		}else if(actionType === 'forfinalpay'){
			forFinalPayHandler({mode: 'reload', recordId})
		}else if(actionType === 'cancel'){
        	deleteHandler({mode: 'reload', recordId})
		}else if(actionType === 'approve'){
			approveHandler(recordId);
		}else if(actionType === 'reject'){
        	rejectHandler(recordId);
		}else{
			deleteHandler({mode: 'reload', recordId})
		}
	}

	const onClosePopupModal = () => {
		if(closeHandler){ closeHandler(); }
		hideModal(recordId);
		setDropdownOpen(false);
	}
	
  	return (
		  <div>
	    	{items?.length > 0 &&
				<Dropdown
					open={dropdownOpen} 
					onOpenChange={setDropdownOpen}
					menu={{items}}
					dropdownRender={(menu) => (
						<div style={contentStyle}>
							{React.cloneElement(menu, {
								style: menuStyle,
							})}			          
						</div>
					)}       		
				>
					<div className={buttonClassName}>
						<Space>
							Action
							<DownOutlined />
						</Space>
					</div>
				</Dropdown>
			}
		  	<Modal
                open={open}
                closeIcon={false}
                centered
				title={<h2 className="popup-modal-title">{confirmTitle}</h2>}
                okText="Confirm"
                cancelText="Cancel"
                footer={(_) => (
                    <>
                        <Button className="me-4 btn-primary" 
                            onClick={(e) => {setOpen(false)}}
                        >
                            Cancel
                        </Button>
                        <Button className="btn-primary"
                            onClick={(e) => {setOpen(false); onClickConfirmation()}}
                        >
                            Confirm
                        </Button>
                    </>
                )}
            >
				<div className='content-wrapper'>{confirmMessage}</div>
            </Modal>

			{viewMode === "modal" && (
				<IndexModal
					open={isVisible}
					onClose={onClosePopupModal}
					title={title}
					width={modalWidth || "sm:max-w-lg max-w-2xl"}
					modalContainerClass={modalContainerClass}
					useCustomClass={useCustomClass}
				>
					{viewHandler ? viewHandler(currentId, onClosePopupModal) : null}
				</IndexModal>
			)}	

			{editMode === "modal" && (
				<IndexModal
					key={currentId}
					open={isVisible}
					onClose={onClosePopupModal}
					title={title}
					width={modalWidth || "sm:max-w-lg max-w-2xl"}
					modalContainerClass={modalContainerClass}
					useCustomClass={useCustomClass}
				>
					{editHandler ? editHandler(currentId, onClosePopupModal) : null}
				</IndexModal>
			)}

			{detailMode === "modal" && (
				<IndexModal
					key={currentId}
					open={isVisible}
					onClose={onClosePopupModal}
					useCustomClass={useCustomClass}
					maxContentHeight="90vh"
					width={modalWidth || "sm:max-w-lg max-w-2xl"}
					zIndex={1001}
				>
					{detailHandler ? detailHandler(currentId, onClosePopupModal) : null}
				</IndexModal>
			)}
	  	</div>
  );
}
const mapStateToProps = (state) => ({
	activeModals: state.layout.activeModals,
});

const mapDispatchToProps = (dispatch) => ({
	showModal: (id) => dispatch(addActiveModal(id)),
	hideModal: (id) => dispatch(removeActiveModal(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CrudOption);
